import {yup} from 'libs/yup'

export const schema = yup.object({
  attachments: yup.array(yup.string().required()).required(),
  uploads: yup
    .array(
      yup.object({
        id: yup.string().notRequired(),
        file: yup.mixed<File>().required().file().fileSize().label('添付ファイル'),
      })
    )
    .required()
    .label('添付ファイル'),
})

export type Schema = yup.InferType<typeof schema>
